import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgTun = function SvgTun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.64 11.124a5.465 5.465 0 0 0-2.195-.457c-2.99 0-5.415 2.388-5.415 5.333 0 2.945 2.424 5.333 5.415 5.333.782 0 1.525-.163 2.196-.457A6.126 6.126 0 0 1 16.09 22C12.727 22 10 19.314 10 16s2.727-6 6.091-6c1.325 0 2.55.416 3.55 1.124Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.111 17.442-1.586 2.093-.053-2.625-2.48-.863 2.48-.862.053-2.625 1.586 2.093 2.514-.76-1.5 2.154 1.5 2.156-2.514-.76Z",
    fill: "#E94B35"
  }));
};

export default SvgTun;